module.exports = __webpack_public_path__ + "res/glyphicons-halflings-regular.woff2?448c34a56d699c29117adc64c43affeb";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2
// module id = 6
// module chunks = 0